export default __webpack_public_path__ + "static/media/map.73948584.png";